import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,getKCISData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Select,Modal, message  } from 'antd';
import { EditOutlined,PlusOutlined,DeleteOutlined,MoreOutlined } from '@ant-design/icons' ;
import Pagination from "react-js-pagination";
import { Menu, Dropdown,Space } from 'antd';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import $ from 'jquery';

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import add from '../../assets/images/icon/add.png';
import edit from '../../assets/images/icon/edit.png';
import boy from '../../assets/images/icon/boy.png';
import girl from '../../assets/images/icon/girl.png';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			school_list: [],
			tab: '1',
			page: 1,
			total_count:0,
			perPage: 10,
		}
		this.onChangePage = this.onChangePage.bind(this);	
		this.change_pagination = this.change_pagination.bind(this);	
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			const params = new Proxy(new URLSearchParams(window.location.search), {
			    get: (searchParams, prop) => searchParams.get(prop),
			 });
			if(params.t!=null && params.s!=null){
				let token = params.t;
				let erp_id = params.s;
				var app = {token:token,erp_id:erp_id}
				var new_id = erp_id.split('_');
				getKCISData('auth/verify_token',app).then((result) => {
					let responseJson = result;
					if(responseJson){
						if(result['status'] == 200){
							localStorage.setItem('schoolData',JSON.stringify(responseJson));
							localStorage.setItem("app_token",params.t);
							var erp_id = result['data'][0]['erp_id'];
							var erp_type = erp_id.split('_');
							localStorage.setItem("erp_id",erp_id);
							localStorage.setItem("erp_type",erp_type[0]);
							window.location.reload(false);
						}
					}
				});
			}
		}else{
			const params = new Proxy(new URLSearchParams(window.location.search), {
			    get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.t!=null && params.s!=null){
				var app_token = localStorage.getItem("app_token");
				var check_id = localStorage.getItem("erp_id");
				if(params.t != app_token || check_id!=params.s){
					let token = params.t;
					let erp_id = params.s;
					var app = {token:token,erp_id:erp_id}
					var new_id = erp_id.split('_');
					getKCISData('auth/verify_token',app).then((result) => {
						let responseJson = result;
						if(responseJson){
							if(result['status'] == 200){
								localStorage.setItem('schoolData',JSON.stringify(responseJson));
								localStorage.setItem("app_token",params.t);
								var erp_id = result['data'][0]['erp_id'];
								var erp_type = erp_id.split('_');
								localStorage.setItem("erp_id",erp_id);
								localStorage.setItem("erp_type",erp_type[0]);
								window.location.reload(false);
							}
						}
					});
				}
			}
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		this.checkData()
	}
	
	onChangePage=(pageNumber)=>{
	    this.setState({ page : pageNumber });
	    setTimeout(() => {
		 this.checkData();
	    }, 500);
	}
	
	change_pagination(event){
		this.setState({
            perPage: event
        })
		setTimeout(() => {
			this.checkData();
		}, 500);
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,page:this.state.page,}
			getData('Timetable/timetable_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_count: result['total_data'],
						});
					}else{
						this.setState({
							school_list: [],
							total_count : 0
							
						});
					}
				}
			});
	}
  }
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	  };
	  
	 handletabchange=(e)=>{
			this.setState({
					tab: e,
				});
			
	} 
	
	showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  
  showMenu= (id, e) =>  {
		e.preventDefault();
		//console.log(this.state.showMenu);
		
		if(this.state.showMenu == 1){
			
			setTimeout(() => {
					$(".action-menu").attr('class', 'action-menu');
					document.getElementById('open_action_' + id).classList.remove('is-active');
					this.setState({
					  showMenu: 0,
					});
			}, 30);
			
		}else{
			
			setTimeout(() => {
					//console.log(this.state.showMenu)
					
					document.getElementById('open_action_' + id).classList.add('is-active');
					this.setState({
					  showMenu: 1,
					});
			}, 30);
			
		}
		
		
	}
	
	handledelete=(e)=>{
		
		var app = {
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			id : e,
		}
		
		getData('Timetable/delete_timetable',app).then((result) => {
			if(result.status==200){
				message.config({ top: 150});
				message.success('Deleted Successfull',2);
				setTimeout(() => {
					this.checkData()
				}, 30);
				
			}
		});
	 

	}

	render()

	{
	var lenght = this.state.school_list.length; 
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div class="row bred">
				<div class="col-md-12">
				<div class="card">
				<div class="card-body">
					<h4 class="page-title"> 
						<i class="mdi mdi-apple-keyboard-command title_icon"></i>Time Table
						<Link to={`${process.env.PUBLIC_URL}/time-table/add`} className="btn btn-outline-primary btn-rounded alignToTitle"><i class="mdi mdi-plus"></i> Add 
									</Link>
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item">
									<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
									<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
									</a>
								</li>
								<li class="breadcrumb-item"> Time Table </li>
							</ol>
						</div>
					</h4>
				</div>
				</div>
				</div>
			</div>
			
			<ul class="nav nav-tabs nav-tabs-solid">
				<li class="nav-item"><a href={`${process.env.PUBLIC_URL}/time-table/list`} class="nav-link active">Time Table List</a></li>
				<li class="nav-item"><a href={`${process.env.PUBLIC_URL}/time-table/manage`} class="nav-link">Time Table Manage</a></li>
			</ul>
		 	
           
		   <div class="row home-dash">
                     <div class="col-lg-12 mb-3 form-group">
					 <div class="card">
						<div class="card-body">
						<div class="row ">
						<div class="col-sm-9 col-9 text-left  enquiry-btn ">
							<h4 class="header-title mt-5px">Total : {this.state.total_count}</h4>
						</div>
						<div class="col-3 text-md-end hide-desktop">
							<a href={`${process.env.PUBLIC_URL}/time-table/add`} ><button type="button" class="btn btn-primary float-right mr-2"> <i class="mdi mdi-plus"></i> Add </button></a>
						</div>
						</div>
						
						<div class="table-responsive">
							<table class="table table-striped table-bordered table-hover">
								<thead>
									<tr>
										<th>Sr. No.</th>
										<th>Academic Year</th>
										<th>Class Name</th>
										<th>Created Date</th>
										<th>Action</th>
									</tr>
								</thead>
								<tbody>
								{this.state.school_list.map((list) => (
									<tr>
										<td data-label="#">{list.sr_no}</td>
										<td data-label="Academic Year">{list.academic_year}</td>
										<td data-label="Class Name">{list.class}</td>
										<td data-label="Created Date">{list.added_date}</td>
										
										<td data-label="Action">
											<a class="ml-10" href="#" onClick={this.handledelete.bind(this,list.id)} ><button type="button" class="btn mr-1 mb-1 label-danger-1"> <DeleteOutlined /> Delete</button></a>
												
										</td>
									</tr>
								))}
								{(() => {  
								if (lenght =='0') {
											return (
												<td id="error" class="center" colspan="5">No Data Found</td>
											)
									}
								})()}
								</tbody>
							</table>
						</div>
						<div class="fl-right">
							<Pagination
								activePage={this.state.page}
								itemsCountPerPage={10}
								totalItemsCount={this.state.total_count}
								pageRangeDisplayed={3}
								onChange={this.onChangePage.bind(this)}
							/>
						</div>
            
			</div>
			</div>
			</div>
			</div>
			</div>
		) 
	} 
}
export default Index;
